import { render, staticRenderFns } from "./externalRecordList.vue?vue&type=template&id=b042256a&"
import script from "./externalRecordList.vue?vue&type=script&lang=js&"
export * from "./externalRecordList.vue?vue&type=script&lang=js&"
import style0 from "./externalRecordList.vue?vue&type=style&index=0&id=b042256a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports